<template>
  <div>
    <gg-modal :is-active="showInvoiceModal" @close="closeInvoiceModal">
      <template v-slot:toolbar>
        {{ title }}
      </template>
      <template v-slot:body>
        Would you like proceed to invoice #{{ invoiceId }}?
      </template>
      <template v-slot:actions>
        <gg-btn @click="viewInvoice">View Invoice</gg-btn>
        <gg-btn @click="closeInvoiceModal" secondary>Close</gg-btn>
      </template>
    </gg-modal>
  </div>
</template>

<script>
export default {
  name: 'ShowInvoiceModal',

  props: {
    title: {
      type: String,
      required: true
    },
    invoiceId: {
      type: String,
      required: true
    },
  },

  data () {
    return {
      showInvoiceModal: false,
    }
  },

  methods: {
    closeInvoiceModal () {
      this.showInvoiceModal = false
    },
    openInvoiceModal () {
      this.showInvoiceModal = true
    },
    viewInvoice () {
      this.$router.push({
        name: 'single_invoice',
        params: { invoiceid: this.invoiceId },
      })
    },
  },
}
</script>

<style scoped>
</style>
